<template>
  <section class="hero-section">
    <div class="hero-overlay"></div>
    <div class="animated-gradient"></div>
    
    <div class="floating-elements">
      <div class="float-circle circle-1"></div>
      <div class="float-circle circle-2"></div>
      <div class="float-circle circle-3"></div>
    </div>

    <div class="hero-content">
      <!-- <div class="badge" data-aos="fade-down">
        <span class="badge-icon">🏆</span>
        <span>20+ Years of Excellence in Transport Safety</span>
      </div> -->
      
      <h1 class="hero-title" data-aos="fade-up" data-aos-delay="100">
        STE Hoza Logistique <br />
        <span class="gradient-text">Conseil</span>
      </h1>
      
      <p class="hero-subtitle" data-aos="fade-up" data-aos-delay="200">
        {{ $t('home-page.home.sub-title') }}
      </p>

      <div class="cta-container" data-aos="fade-up" data-aos-delay="300">
        <router-link to="/habit-safe" class="cta-primary">
          <span>Discover HABITSAFE</span>
          <svg class="arrow-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
          </svg>
        </router-link>
        
        <router-link to="/contact" class="cta-secondary">
          <span>Get Started</span>
        </router-link>
      </div>

      <div class="trust-indicators" data-aos="fade-up" data-aos-delay="400">
        <div class="indicator">
          <div class="indicator-value">20+</div>
          <div class="indicator-label">Years Experience</div>
        </div>
        <div class="divider"></div>
        <!-- <div class="indicator">
          <div class="indicator-value">ISO</div>
          <div class="indicator-label">Certified Standards</div>
        </div> -->
        <div class="divider"></div>
        <div class="indicator">
          <div class="indicator-value">100%</div>
          <div class="indicator-label">Safety Focused</div>
        </div>
      </div>
    </div>

    <div class="scroll-indicator" data-aos="fade-up" data-aos-delay="500">
      <div class="scroll-mouse">
        <div class="scroll-wheel"></div>
      </div>
      <span class="scroll-text">Scroll to explore</span>
    </div>
  </section>
</template>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  // Add parallax effect on scroll
  window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset
    const heroSection = document.querySelector('.hero-section')
    if (heroSection) {
      heroSection.style.transform = `translateY(${scrolled * 0.5}px)`
    }
  })
})
</script>

<style scoped>
.hero-section {
  height: 100vh;
  width: 100%;
  background: url('@/assets/rectangle-2@2x.webp') no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  color: white;
  overflow: hidden;
  transition: transform 0.1s ease-out;
}

/* Animated Gradient Overlay */
.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(10, 45, 97, 0.85) 0%, rgba(15, 23, 42, 0.9) 100%);
  z-index: 1;
}

.animated-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    rgba(252, 188, 13, 0.1) 0%,
    transparent 50%,
    rgba(59, 130, 246, 0.1) 100%
  );
  animation: gradientShift 8s ease infinite;
  z-index: 1;
}

@keyframes gradientShift {
  0%, 100% { opacity: 0.3; transform: translateX(0) translateY(0); }
  50% { opacity: 0.6; transform: translateX(20px) translateY(-20px); }
}

/* Floating Elements */
.floating-elements {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  pointer-events: none;
}

.float-circle {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(252, 188, 13, 0.15) 0%, transparent 70%);
  animation: float 20s ease-in-out infinite;
}

.circle-1 {
  width: 400px;
  height: 400px;
  top: -100px;
  left: -100px;
  animation-delay: 0s;
}

.circle-2 {
  width: 300px;
  height: 300px;
  bottom: -50px;
  right: -50px;
  animation-delay: 3s;
}

.circle-3 {
  width: 250px;
  height: 250px;
  top: 50%;
  right: 10%;
  animation-delay: 6s;
}

@keyframes float {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(30px, -30px) scale(1.1); }
  66% { transform: translate(-20px, 20px) scale(0.9); }
}

/* Hero Content */
.hero-content {
  position: relative;
  z-index: 2;
  padding: 2rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 40px;
}

/* Badge */
.badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(252, 188, 13, 0.3);
  padding: 12px 24px;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 2rem;
  animation: pulse 3s ease-in-out infinite;
}

.badge-icon {
  font-size: 1.2rem;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(252, 188, 13, 0.4); }
  50% { transform: scale(1.05); box-shadow: 0 0 20px 10px rgba(252, 188, 13, 0); }
}

/* Hero Title */
.hero-title {
  font-family: 'Poppins', sans-serif;
  font-size: 3.2rem;
  font-weight: 900;
  line-height: 1.1;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
  letter-spacing: 3px;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  animation: titleReveal 1s ease-out;
}

@keyframes titleReveal {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

.gradient-text {
  background: linear-gradient(135deg, #fcbc0d 0%, #fbbf24 50%, #f59e0b 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: inline-block;
  animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer {
  0%, 100% { filter: brightness(1); }
  50% { filter: brightness(1.3); }
}

/* Hero Subtitle */
.hero-subtitle {
  font-size: 1rem;
  font-weight: 300;
  max-width: 700px;
  margin: 0 auto 3rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

/* CTA Container */
.cta-container {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 4rem;
}

.cta-primary {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #fcbc0d 0%, #f59e0b 100%);
  color: #0a2d61;
  padding: 18px 40px;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 700;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 10px 30px rgba(252, 188, 13, 0.4);
  position: relative;
  overflow: hidden;
}

.cta-primary::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.6s;
}

.cta-primary:hover::before {
  left: 100%;
}

.cta-primary:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 15px 40px rgba(252, 188, 13, 0.6);
}

.arrow-icon {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
}

.cta-primary:hover .arrow-icon {
  transform: translateX(5px);
}

.cta-secondary {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  color: white;
  padding: 18px 40px;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.cta-secondary:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(252, 188, 13, 0.8);
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(255, 255, 255, 0.2);
}

/* Trust Indicators */
.trust-indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  flex-wrap: wrap;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 2rem 3rem;
  border-radius: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.indicator {
  text-align: center;
}

.indicator-value {
  font-size: 2.5rem;
  font-weight: 900;
  color: #fcbc0d;
  line-height: 1;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 10px rgba(252, 188, 13, 0.5);
}

.indicator-label {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.8);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 500;
}

.divider {
  width: 1px;
  height: 50px;
  background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.3), transparent);
}

/* Scroll Indicator */
.scroll-indicator {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  z-index: 2;
  animation: bounce 2s ease-in-out infinite;
}

@keyframes bounce {
  0%, 100% { transform: translateX(-50%) translateY(0); }
  50% { transform: translateX(-50%) translateY(-10px); }
}

.scroll-mouse {
  width: 30px;
  height: 50px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 20px;
  position: relative;
}

.scroll-wheel {
  width: 4px;
  height: 10px;
  background: #fcbc0d;
  border-radius: 2px;
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  animation: scrollWheel 2s ease-in-out infinite;
}

@keyframes scrollWheel {
  0%, 100% { top: 8px; opacity: 1; }
  50% { top: 20px; opacity: 0.5; }
}

.scroll-text {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 500;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .hero-title {
    font-size: 4rem;
  }
  
  .hero-subtitle {
    font-size: 1.3rem;
  }
  
  .trust-indicators {
    gap: 2rem;
    padding: 1.5rem 2rem;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 2.8rem;
    letter-spacing: 1px;
  }
  
  .hero-subtitle {
    font-size: 1.1rem;
    margin-bottom: 2rem;
  }
  
  .badge {
    font-size: 0.8rem;
    padding: 10px 20px;
  }
  
  .cta-container {
    flex-direction: column;
    gap: 1rem;
  }
  
  .cta-primary,
  .cta-secondary {
    width: 100%;
    max-width: 300px;
    justify-content: center;
    padding: 16px 32px;
    font-size: 1rem;
  }
  
  .trust-indicators {
    gap: 1.5rem;
    padding: 1.5rem;
  }
  
  .indicator-value {
    font-size: 2rem;
  }
  
  .indicator-label {
    font-size: 0.75rem;
  }
  
  .divider {
    display: none;
  }
  
  .float-circle {
    opacity: 0.5;
  }
  
  .circle-1 {
    width: 250px;
    height: 250px;
  }
  
  .circle-2 {
    width: 200px;
    height: 200px;
  }
  
  .circle-3 {
    width: 150px;
    height: 150px;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 2.2rem;
  }
  
  .hero-subtitle {
    font-size: 1rem;
  }
  
  .trust-indicators {
    flex-direction: column;
    gap: 1rem;
  }
}
</style>
